import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { PartPackageService } from '@app/api/api';
import { environment } from 'environments/environment';
import { debounceTime, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ModalPartPackageComponent } from '../modal-part-package/modal-part-package.component';

export interface PartPackage {
  id: string | number;
  name: string;
  description?: string;
  serial?: string;
  default_image?: string;
  brand_id?: string | null;
  equipment_model_id?: string;
  extend_equipment_model?: {
    id?: string;
    model_code?: string;
    description?: string;
    default_image?: string;
  };
  prefixes?: { id: string; prefix_code: string }[] | null;
  is_active: boolean;
}

@Component({
  selector: 'meu-part-package-management',
  templateUrl: './part-package-management.component.html',
  styleUrls: ['./part-package-management.component.scss'],
})
export class PartPackageManagementComponent implements OnInit {
  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private partPackageService: PartPackageService,
    private router: Router
  ) {}

  displayedColumns: string[] = ['Index', 'Image', 'Name', 'Serial', 'ModelName', 'Prefixes', 'IsActive', 'Actions'];
  lstAll: PartPackage[] = [];
  total: number = 0;
  pageSize = 10;
  pageIndex = 1;
  host: string = '';
  filter: string = '';
  pageSizeOptions: number[] = [5, 10, 20, 100];
  statusFilter: string = 'all';
  searchValue: string = '';

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(500)
      )
      .subscribe((value) => {
        this.searchValue = value;
        this.pageIndex = 1;
        this.buildFilter();
        this.getAll();
      });
    this.getAll();
  }

  public keyUp = new Subject<string>();

  buildFilter() {
    let filterParts = [];

    if (this.searchValue) {
      filterParts.push(`(name|description|serial)@=*${this.searchValue}`);
    }

    if (this.statusFilter !== 'all') {
      filterParts.push(`is_active==${this.statusFilter === 'active'}`);
    }

    this.filter = filterParts.join(';');
  }

  onStatusFilterChange() {
    this.pageIndex = 1;
    this.buildFilter();
    this.getAll();
  }

  getAll() {
    this.partPackageService
      .apiPartPackagesGet(this.filter, '', this.pageIndex, this.pageSize)
      .subscribe((res) => {
        if (res.success) {
          this.lstAll = res.data.collection;
          this.total = res.data.total;
          this.host = environment.backendhost;
          this.ref.detectChanges();
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getAll();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 1;
    this.getAll();
  }

  openModal(id: string | number) {
    const dialogRef = this.dialog.open(ModalPartPackageComponent, {
      width: '700px',
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result.event != undefined) {
        if (result.event) {
          if (result.type == 'create') {
            this.toastr.success('Tạo gói phụ tùng thành công');
            this.getAll();
          } else {
            this.toastr.success('Cập nhật gói phụ tùng thành công');
            this.getAll();
          }
        } else {
          this.toastr.error(result.message);
        }
      }
    });
  }

  viewDetail(packageId: string | number) {
    this.router.navigate(['/admin/part-package-management', packageId, 'items']);
  }

  deleteItem(id: string | number) {
    const title = 'Xóa gói phụ tùng';
    const description = 'Bạn có chắc chắn muốn xóa gói phụ tùng này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.partPackageService.apiPartPackagesIdDelete(String(id)).subscribe((res) => {
          if (res.success) {
            this.toastr.success('Xoá gói phụ tùng thành công');
            this.getAll();
          } else {
            this.toastr.error(res.message);
          }
        });
      }
    });
  }
}
